import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UserInfoPanel from '../budgetAuth/UserInfoPanel';
import { actions as authActions } from '../../actions/budgetAuthActions';
import { bindActionCreators } from 'redux';
import Paper from '@material-ui/core/Paper';
import LoadingIndicator from '../LoadingIndicator';
import ParticipantVotes from './ParticipantVotes';
import { useMyVotes } from '../../hooks/useBudgetVoting';

const ParticipantVotesPage = ({ auth, authActions, account }) => {
  const { data: votes, isLoading, error } = useMyVotes(true);

  return (
    <React.Fragment>
      <div key="top" className="row top">
        <div className="col-sm-2" />
        <div className="col-sm-3" />
        <div className="col-sm-7 header">
          <UserInfoPanel auth={auth} authenticationRequired={true}
            authActions={authActions} account={account} />
        </div>
      </div>
      <div key="content" style={{ marginTop: 40, marginBottom: 40 }}>
        <LoadingIndicator fetching={isLoading}>
          <Paper style={{ overflowX: 'auto' }}>
            <ParticipantVotes votes={votes} error={error} />
          </Paper>
        </LoadingIndicator>
      </div>
    </React.Fragment>
  );
};

ParticipantVotesPage.propTypes = {
  auth: PropTypes.object,
  authActions: PropTypes.object.isRequired,
  account: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    auth: state.budgetAuth,
    account: state.budgetAccount.data,    
  };
}

function mapDispatchToProps(dispatch) {
  return {
    authActions: bindActionCreators(authActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ParticipantVotesPage);



// WEBPACK FOOTER //
// ./src/components/budget/ParticipantVotesPage.js